import Pro from './pro'

export default Pro